module.exports = __webpack_public_path__ + "static/media/ski-jump.f9517f33.svg";